import { useState } from 'react';
import { useUpdateTaskStatusMutation } from '../../../../api/tareas/tareaApi';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';

interface Props {
    taskId: number;
    taskStatus: boolean;
}

export function FinishTaskButton({ taskId, taskStatus }: Props) {
    const [changeTaskStatus, { isLoading: changeStatusIsLoading }] = useUpdateTaskStatusMutation();

    const [isFinished, setIsFinished] = useState(taskStatus);

    const onChangeStatus = async (event: React.MouseEvent<HTMLDivElement, MouseEvent>,newStatus: boolean) => {
        try {
            event.stopPropagation();
            setIsFinished(newStatus);

            const request = {
                taskId,
                terminada: newStatus,
            };

            await changeTaskStatus(request).unwrap();
            
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <>
            {isFinished
            ? 
            <div 
                onClick={(event) => onChangeStatus(event, false)}
                className="border-2 border-emerald-400 bg-emerald-100 h-[20px] w-[20px] rounded-full flex justify-center items-center cursor-pointer">
                <DoneRoundedIcon sx={{
                    height: 20,
                    width: 20,
                    color: "#34d399",
                }}/>
            </div>
            :
            <div
                onClick={(event) => onChangeStatus(event,true)}
                className="border-2 border-gray-500 bg-gray-100 h-[20px] w-[20px] rounded-full flex justify-center items-center cursor-pointer" />
            }
        </>
    );
}
